import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { Button, Container, Grid, Paper, Stack, Typography, Box } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { dateFormatter, getMonthYear } from '../../../../../utils';

const GRN_HEADER = [
  {
    header: 'Invoice No.',
    accessor: 'cnt'
  },
  {
    header: 'Supplier',
    accessor: (row) => row?.supplier?.ledger_name
  },
  {
    header: 'Location',
    accessor: (row) => row?.location?.warehouse_name
  }
];

const GRN_DETAILS_HEADER = [
  {
    header: 'Product Name',
    accessor: (row) => row?.product?.name
  },
  {
    header: 'Unit',
    accessor: 'unit'
  },
  {
    header: 'Bill Qty',
    accessor: 'bill_qty'
  },
  {
    header: 'Free Qty',
    accessor: 'free_qty'
  },
  {
    header: 'Rate',
    accessor: 'rate'
  },
  {
    header: 'Discount',
    accessor: 'dis_amt'
  },
  {
    header: 'Batch',
    accessor: 'batch_no'
  },
  {
    header: 'Stock',
    accessor: 'total_qty'
  },
  {
    header: 'Expiry',
    accessor: (row) => getMonthYear(row?.exp_date)
  }
];

const STOCK_TABLE_HEADER = [
  {
    header: 'GRN/CNT No',
    accessor: (row) => row?.grn || row?.cnt
  },
  {
    header: 'Product Name',
    accessor: (row) => row?.product?.name
  },
  {
    header: 'Supplier',
    accessor: (row) => row?.supplier?.ledger_name
  },
  {
    header: 'Unit',
    accessor: 'unit'
  },
  {
    header: 'Rate',
    accessor: 'rate'
  },
  {
    header: 'Batch',
    accessor: 'batch_no'
  },
  {
    header: 'Stock',
    accessor: 'total_qty'
  },
  {
    header: 'Expiry',
    accessor: (row) => getMonthYear(row?.exp_date)
  }
];

const initialInvestiagtionBookingDataObj = {
  data: [],
  loading: false
};

export const StorePurchaseAuthorize = () => {
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [grn, setGrn] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(false);
  const [productDetails, setProductDetails] = useState([]);
  const [consignment, setConsignment] = useState([]);
  const [mergedData, setMergedData] = useState([]);
  const [stock, setStock] = useState([]);
  const { pathname } = useLocation();
  const [stockDetails, setStockDetails] = useState([]);
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const user = JSON.parse(localStorage.getItem('user'));

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      date: getCurrentDateTime('date'),
      time: getCurrentDateTime('time'),
      bill: {
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });

  const { handleSubmit, reset, setValue } = methods;
  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setValue('uhid', selectedRecord.uhid);
      setDetailList(selectedRecord.service_items);
      setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
      setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));
    } else {
      reset();
    }
  }, [selectedRecord]);

  const handleRowDelete = (rowId) => {
    setDetailList((prev) => prev.filter((data) => data.id !== rowId));
  };

  const getGrnAndConsignmentData = useCallback(async () => {
    try {
      const grnData = await dropdownFetch('store-grn-unauthorise');
      const consignmentData = await dropdownFetch('store-consignment-receipt-unauthorise');
      const merged = [...grnData, ...consignmentData];
      setMergedData(merged);
      setSelectedProduct(merged);
      setSelectedProduct(true);
    } catch (error) {
      console.error('Error fetching or processing data:', error);
    }
  }, []);

  useEffect(() => {
    getGrnAndConsignmentData();
  }, [getGrnAndConsignmentData]);

  const handleRowClick = (row) => {
    const updatedProductDetails = row.add_details.map((detail) => ({
      ...detail,
      supplier: row.supplier._id,
      cnt: row.cnt
    }));
    setProductDetails(updatedProductDetails);
  };

  const filterUniqueProducts = (consignmentData) => {
    const filteredData = consignmentData.reduce((acc, current) => {
      const x = acc.find((item) => item.batch_no === current.batch_no);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    return filteredData;
  };

  useEffect(() => {
    console.log('HELLLO PRODUCTDETAILS', productDetails);
  }, [productDetails]);

  const formSubmit = async () => {
    setLoading(true);
    const updatedProductDetails = productDetails.map((productDetail) => ({
      ...productDetail,
      product: productDetail.product?._id,
      hsn_code: productDetail.hsn_code,
      mrp: productDetail.mrp,
      conversion: productDetail.conversion,
      supplier: productDetail.supplier,
      unit: productDetail.unit,
      bill_qty: productDetail.bill_qty,
      packing: productDetail.packing,
      free_qty: productDetail.free_qty,
      rate: productDetail.rate,
      gst: productDetail.gst,
      dis_amt: productDetail.dis_amt,
      dis_percent: productDetail.dis_percent,
      batch_no: productDetail.batch_no,
      total_qty: productDetail.total_qty,
      mfg_date: productDetail.mfg_date,
      exp_date: productDetail.exp_date
    }));

    const payload = {
      productDetails: updatedProductDetails
    };

    console.log('Payload:', payload);

    try {
      const response = await request('/store-stock-master-create', {
        method: 'POST',
        body: {
          ...payload,
          createdBy: user.name,
          organisation
        }
      });

      if (response?.success) {
        toast('Stock details successfully submitted to StockMaster!', { variant: 'success' });
        getGrnAndConsignmentData();
      } else {
        throw new Error('Failed to submit stock details.');
      }
    } catch (error) {
      toast(`Error: ${error.message}`, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const fetchStock = async () => {
    const response = await request('/store-stock-master-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setStock({ loading: false, data: sortedData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setStock({ loading: false });
    }
  };

  useEffect(() => {
    fetchStock();
  }, []);

  const handleRowProduct = (row) => {
    if (stock.data && stock.data.length > 0) {
      const allProductDetails = stock.data.flatMap((dataItem) => dataItem.productDetails || []);
      const matchingProducts = allProductDetails.filter(
        (productDetail) => productDetail.product._id === row.product._id
      );
      if (matchingProducts.length > 0) {
        const sortedMatchingProducts = matchingProducts.sort((a, b) => {
          const dateA = new Date(a.createdAt);
          const dateB = new Date(b.createdAt);
          return dateB - dateA;
        });
        setStockDetails(sortedMatchingProducts);
        console.log('Matching Stock Details (Sorted)', sortedMatchingProducts);
      } else {
        setStockDetails([]);
      }
    } else {
      setStockDetails([]);
    }
  };

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Purchase Authorize
              </Typography>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                {/* First Table */}
                <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Table
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                    data={mergedData || []}
                    columns={GRN_HEADER}
                    size="small"
                    onRowClick={handleRowClick}
                    showAuthorize={true}
                    onAuthorizeHandler={formSubmit}
                  />
                </Grid>
                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Table
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                    data={productDetails || []}
                    columns={GRN_DETAILS_HEADER}
                    size="small"
                    onRowClick={(row) => {
                      handleRowProduct(row);
                    }}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, marginTop: '2%' }}>
                <Table
                  containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                  data={stockDetails || []}
                  columns={STOCK_TABLE_HEADER}
                  size="small"
                />
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
